import hash from 'object-hash';

export default function (object): string {
  return hash(object, {
    unorderedObjects: true
  });
}
